"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var auth0_react_1 = require("@auth0/auth0-react");
var antd_1 = require("antd");
require("antd/dist/antd.css");
var icons_1 = require("@ant-design/icons");
var react_router_dom_1 = require("react-router-dom");
var package_json_1 = __importDefault(require("../../package.json"));
var actions_1 = require("../modules/asset_types/actions");
var actions_2 = require("../modules/assets/actions");
var actions_3 = require("../modules/categories/actions");
var actions_4 = require("../modules/feedback/actions");
var actions_5 = require("../modules/layers/actions");
var actions_6 = require("../modules/modals/actions");
var actions_7 = require("../modules/pages/actions");
var actions_8 = require("../modules/releases/actions");
var actions_9 = require("../modules/sections/actions");
var actions_10 = require("../modules/settings/actions");
var actions_11 = require("../modules/server/actions");
var actions_12 = require("../modules/stations/actions");
var utils_1 = require("../utils");
var AssetsPage_1 = __importDefault(require("./assets/AssetsPage"));
var CategoriesPage_1 = __importDefault(require("./categories/CategoriesPage"));
var FeedbackPage_1 = __importDefault(require("./feedback/FeedbackPage"));
var LayerPage_1 = __importDefault(require("./layers/LayerPage"));
var ModalsPage_1 = __importDefault(require("./modals/ModalsPage"));
var PagesPage_1 = __importDefault(require("./pages/PagesPage"));
var ReleasePage_1 = __importDefault(require("./releases/ReleasePage"));
var SectionsPage_1 = __importDefault(require("./sections/SectionsPage"));
var StationsPage_1 = __importDefault(require("./stations/StationsPage"));
var SettingsPage_1 = __importDefault(require("./settings/SettingsPage"));
var SearchBar_1 = __importDefault(require("./SearchBar"));
var hooks_1 = require("../hooks");
var hooks_2 = require("../modules/server/hooks");
var OBJECT_TYPES = [
    {
        key: "stations",
        label: react_1.default.createElement(react_router_dom_1.Link, { to: "/stations" }, "Stations"),
        icon: react_1.default.createElement(icons_1.EnvironmentOutlined, null),
        fetchAll: actions_12.fetchStationsIfNeeded,
    },
    {
        key: "sections",
        label: react_1.default.createElement(react_router_dom_1.Link, { to: "/sections" }, "Sections"),
        icon: react_1.default.createElement(icons_1.DatabaseOutlined, null),
        fetchAll: actions_9.fetchSectionsIfNeeded,
    },
    {
        key: "categories",
        label: react_1.default.createElement(react_router_dom_1.Link, { to: "/categories" }, "Categories"),
        icon: react_1.default.createElement(icons_1.PartitionOutlined, null),
        fetchAll: actions_3.fetchCategoriesIfNeeded,
    },
    {
        key: "pages",
        label: react_1.default.createElement(react_router_dom_1.Link, { to: "/pages" }, "Pages"),
        icon: react_1.default.createElement(icons_1.FileOutlined, null),
        fetchAll: actions_7.fetchPagesIfNeeded,
    },
    {
        key: "modals",
        label: react_1.default.createElement(react_router_dom_1.Link, { to: "/modals" }, "Modals"),
        icon: react_1.default.createElement(icons_1.CloseSquareOutlined, null),
        fetchAll: actions_6.fetchModalsIfNeeded,
    },
    {
        key: "assets",
        label: react_1.default.createElement(react_router_dom_1.Link, { to: "/assets" }, "Assets"),
        icon: react_1.default.createElement(icons_1.PictureOutlined, null),
        fetchAll: actions_2.fetchAssetsIfNeeded,
    },
    {
        key: "layers",
        label: react_1.default.createElement(react_router_dom_1.Link, { to: "/layers" }, "Layers"),
        icon: react_1.default.createElement(icons_1.GlobalOutlined, null),
        fetchAll: actions_5.fetchLayersIfNeeded,
    },
    {
        key: "releases",
        label: react_1.default.createElement(react_router_dom_1.Link, { to: "/releases" }, "Releases"),
        icon: react_1.default.createElement(icons_1.AppstoreOutlined, null),
        fetchAll: actions_8.fetchReleasesIfNeeded,
    },
    {
        key: "feedback",
        label: react_1.default.createElement(react_router_dom_1.Link, { to: "/feedback" }, "Feedback"),
        icon: react_1.default.createElement(icons_1.SolutionOutlined, null),
        fetchAll: actions_4.fetchFeedbackIfNeeded,
    },
    {
        key: "settings",
        label: react_1.default.createElement(react_router_dom_1.Link, { to: "/settings" }, "Settings"),
        icon: react_1.default.createElement(icons_1.SettingOutlined, null),
        fetchAll: actions_10.fetchSettingsIfNeeded,
    },
    {
        key: "assetTypes",
        fetchAll: actions_1.fetchAssetTypesIfNeeded,
    },
];
var MENU_ITEMS = OBJECT_TYPES
    .filter(function (t) { return t.label; })
    .map(function (t) { return ({ key: t.key, label: t.label, icon: t.icon }); });
var styles = {
    layout: { height: "100vh" },
    header: { padding: "0 24px" },
    headerInner: { display: "flex" },
    headerText: { minWidth: "220px", padding: 0, color: "#DFDFDF", flex: 1 },
    searchContainer: { flex: 2 },
    authContainer: { flex: 1, color: "white", textAlign: "right" },
    signInLink: { color: "#CCC" },
    sider: { overflowY: "auto" },
    versionContainer: {
        color: "rgba(255, 255, 255, 0.4)",
        padding: "8px 16px",
        display: "flex",
        flexDirection: "column",
        fontFamily: "monospace",
        fontSize: 12,
    },
    content: { overflowY: "auto" },
    signedOut: {
        height: "100%",
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        textAlign: "center",
    },
    signedOutText: { paddingBottom: 8 },
    signedOutAlertOuter: { paddingTop: 16 },
    signedOutAlertInner: { maxWidth: 500, padding: "0 16", margin: "0 auto", textAlign: "left" },
};
var PageHeaderSubtitleSkeleton = react_1.default.memo(function () {
    return react_1.default.createElement(antd_1.Skeleton, { title: false, paragraph: { rows: 1, width: 200 }, style: { marginTop: 12 } });
});
var App = react_1.default.memo(function () {
    var _a = (0, auth0_react_1.useAuth0)(), loginWithRedirect = _a.loginWithRedirect, isLoadingAuth = _a.isLoading, isAuthenticated = _a.isAuthenticated, user = _a.user, getAccessTokenSilently = _a.getAccessTokenSilently;
    var dispatch = (0, hooks_1.useAppDispatch)();
    var location = (0, react_router_dom_1.useLocation)();
    var updateObjects = (0, react_1.useCallback)(function (isInitial) {
        if (!isAuthenticated)
            return;
        // TODO: Don't update if not initial and on an edit page
        var asyncWrapper = function () { return __awaiter(void 0, void 0, void 0, function () {
            var accessToken, typesToUpdate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getAccessTokenSilently(utils_1.ACCESS_TOKEN_READ)];
                    case 1:
                        accessToken = _a.sent();
                        typesToUpdate = OBJECT_TYPES
                            .filter(function (t) { return isInitial || !t.label || (t.label && !location.pathname.startsWith("/".concat(t.key, "/edit"))); });
                        return [4 /*yield*/, Promise.all(typesToUpdate.map(function (t) { return dispatch(t.fetchAll({}, {}, accessToken)); }))];
                    case 2: 
                    // TODO: Alert if we've actually changed something and we're on a detail page
                    return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        return asyncWrapper();
    }, [isAuthenticated, getAccessTokenSilently, location.pathname]);
    (0, react_1.useEffect)(function () {
        var initialFetch = function () { return __awaiter(void 0, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isAuthenticated)
                            return [2 /*return*/];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, dispatch((0, actions_11.fetchServerInfoIfNeeded)())];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, dispatch((0, actions_11.fetchServerConfigIfNeeded)())];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, updateObjects(true)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        console.error(e_1.message);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        initialFetch().catch(function (e) { return console.error(e.message); });
        // Set 20-second update interval to fetch changes to other objects
        var interval = setInterval(function () { return updateObjects(false); }, 20000);
        return function () {
            clearInterval(interval);
        };
    }, [isAuthenticated, updateObjects]);
    var selectedKeys = (0, react_1.useMemo)(function () { return [location.pathname.split("/")[1] || "stations"]; }, [location]);
    var urlParams = (0, react_1.useMemo)(function () { return Object.fromEntries(location.search.slice(1).split("&").map(function (p) {
        var ps = p.split("=");
        return [ps[0], decodeURIComponent(ps[1])];
    })); }, [location]);
    var loadingServerInfo = (0, hooks_1.useAppSelector)(function (state) { return state.server.info.isFetching; });
    var serverInfo = (0, hooks_1.useAppSelector)(function (state) { return state.server.info.data; });
    var siteTitle = (0, hooks_2.useSiteTitle)();
    document.title = siteTitle || "Trail Guide";
    var signIn = (0, react_1.useCallback)(function () { return loginWithRedirect(); }, [loginWithRedirect]);
    // noinspection JSValidateTypes
    return react_1.default.createElement(antd_1.Layout, { style: styles.layout },
        react_1.default.createElement(antd_1.Layout.Header, { style: styles.header },
            react_1.default.createElement("div", { style: styles.headerInner },
                react_1.default.createElement("h1", { style: styles.headerText }, siteTitle),
                react_1.default.createElement("div", { style: styles.searchContainer },
                    react_1.default.createElement(SearchBar_1.default, null)),
                react_1.default.createElement("div", { style: styles.authContainer }, isLoadingAuth ? "" : (isAuthenticated
                    ? react_1.default.createElement("span", null, user.name)
                    : react_1.default.createElement("a", { style: styles.signInLink, onClick: signIn }, "Sign In"))))),
        react_1.default.createElement(antd_1.Layout, null,
            react_1.default.createElement(antd_1.Layout.Sider, { style: styles.sider, collapsedWidth: 0, collapsed: !isAuthenticated || (isAuthenticated && isLoadingAuth) },
                react_1.default.createElement(antd_1.Menu, { theme: "dark", selectedKeys: selectedKeys, items: MENU_ITEMS }),
                react_1.default.createElement("div", { style: styles.versionContainer },
                    react_1.default.createElement("span", null,
                        "Web v",
                        package_json_1.default.version),
                    react_1.default.createElement("span", null,
                        "Server ",
                        !loadingServerInfo && (serverInfo === null || serverInfo === void 0 ? void 0 : serverInfo.version) ? (react_1.default.createElement("span", null,
                            "v", serverInfo === null || serverInfo === void 0 ? void 0 :
                            serverInfo.version)) : null))),
            react_1.default.createElement(antd_1.Layout.Content, { style: styles.content }, isLoadingAuth
                ? (react_1.default.createElement(antd_1.PageHeader, { ghost: false, title: "Loading...", subTitle: react_1.default.createElement(PageHeaderSubtitleSkeleton, null) })) : (isAuthenticated ? (react_1.default.createElement(antd_1.Spin, { spinning: false },
                react_1.default.createElement(react_router_dom_1.Routes, null,
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/assets/*", element: react_1.default.createElement(AssetsPage_1.default, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/categories/*", element: react_1.default.createElement(CategoriesPage_1.default, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/feedback/*", element: react_1.default.createElement(FeedbackPage_1.default, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/layers/*", element: react_1.default.createElement(LayerPage_1.default, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/modals/*", element: react_1.default.createElement(ModalsPage_1.default, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/pages/*", element: react_1.default.createElement(PagesPage_1.default, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/releases/*", element: react_1.default.createElement(ReleasePage_1.default, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/sections/*", element: react_1.default.createElement(SectionsPage_1.default, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/settings/*", element: react_1.default.createElement(SettingsPage_1.default, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/stations/*", element: react_1.default.createElement(StationsPage_1.default, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/", element: react_1.default.createElement(react_router_dom_1.Navigate, { to: "/stations", replace: true }) })))) : (react_1.default.createElement("div", { style: styles.signedOut },
                react_1.default.createElement("div", { style: styles.signedOutText },
                    react_1.default.createElement(antd_1.Typography.Text, null, "You must be authenticated to see this content.")),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(antd_1.Button, { size: "large", type: "primary", onClick: signIn }, "Sign In")),
                urlParams.hasOwnProperty("error_description") ? (react_1.default.createElement("div", { style: styles.signedOutAlertOuter },
                    react_1.default.createElement("div", { style: styles.signedOutAlertInner },
                        react_1.default.createElement(antd_1.Alert, { message: "Authentication Error", description: urlParams["error_description"], type: "error" })))) : null))))));
});
exports.default = App;
